import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconDocumentType } from "@/enums/falcon/documents/falcon-document-type.enum";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon document type filter
 */
export const falconDocumentTypeFilter: CustomFilter = {
  falconDocumentType(value: any): string {
    value = value.toString() as FalconDocumentType;
    if (value === FalconDocumentType.Invoice) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentTypeInvoiceText);
    } else if (value === FalconDocumentType.Assignation) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentTypeAssignationText);
    } else if (value === FalconDocumentType.InvoiceCorrection) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentTypeInvoiceCorrectionText
      );
    } else {
      value = "";
    }
    return value;
  }
};
